import { Text } from '@wix/design-system';
import { sanitizeHtml } from '@wix/wix-chatbot-common/browser';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useMemo } from 'react';

import { TLocalesKeys } from '../../../../../types';
import { isMacOS } from '../../../../../util';
import s from './KeyboardTips.scss';

export const KeyboardTips: FC = () => {
  const { t } = useTranslation();

  const html = useMemo(() => {
    const key: TLocalesKeys = isMacOS() ? 'keyboard_tip_mac' : 'keyboard_tip_win';

    return {
      __html: sanitizeHtml(t(key)),
    };
  }, [t]);

  return (
    <Text
      secondary
      size="tiny"
      dataHook="keyboard-tips"
      className={s.tips}
      dangerouslySetInnerHTML={html}
    ></Text>
  );
};
